import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SimpleTextFilter, Table, getVisibleColumns } from '../../common/Table';
import Loading from '../../common/Loading';
import KwPanel from '../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../hooks/useTableSettings';
import { useTranslation } from 'react-i18next';
import { getGameFranchises } from '../../../api/gameApi';
import { GameFranchiseModel } from '../../../types/swagger-dtos/GamesDtos';
import { ListApiResponse } from '../../../types/apiResponse';

export interface GameFranchiseListProps {
  reload: Date;
  editGameFranchise: (gameFranchise: GameFranchiseModel) => void;
}

function GameFranchiseList({
  reload,
  editGameFranchise
}: GameFranchiseListProps) {
  const { t } = useTranslation();
  const location = useLocation();
  let allColumns = [
    'name'
  ];
  const defaultVisibleColumns = [
    'name'
  ];

  const [franchises, setFranchises] = useState<ListApiResponse<GameFranchiseModel>>();
  const params = new URLSearchParams(location.search);

  const {
    tableSettings,
    handleSetTableSettings: setTableSettings,
    filters,
    filterChange,
    isLoading,
  } = useTableSettings(
    'gameFranchiseList-settings',
    getTableSettingsDefaults({
      defaultSort: 'name',
      defaultVisibleColumns,
    }),
    null,
    getGameFranchises,
    setFranchises,
    reload,
    t('Failed to load game franchises')
  );

  const columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      className: 'nowrap',
      Render: (item: any) =>
        <button className='a' onClick={() => { editGameFranchise(item) }}>{item.name}</button>,
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value: any) => filterChange(col.Key, value)}
            placeholder={t('name...')}
            testId={`${col.Key}-filter-input`}
          />
        ),
      },
    }];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);
  // return an alaska table
  return franchises ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        defaultVisibleColumns={defaultVisibleColumns}
        className="gameFranchiseTable"
        rows={franchises.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={franchises.totalRowCount}
        filteredRowCount={franchises.filteredRowCount}
        scopes={franchises.scopes}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        testId="gameFranchise-list-table"
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}

export default GameFranchiseList;
